import { useFlags, useLDClientError } from 'launchdarkly-react-client-sdk';
import { FeatureFlagsClient } from 'src/lib/constants';

export function usePalletSsccEnabled(): boolean {
  const flags = useFlags();
  const error = useLDClientError();
  const isE2E = process.env.AGRIFUL_ENV === 'e2e' || process.env.E2E_MODE === 'true';
  return !isE2E && !error && flags[FeatureFlagsClient.PalletSscc] === true;
}
